<!-- <div class="w-visit__status"
        [ngClass]="vesselVisitStatusColour(vesselVisit().status)">
    <b>{{ vesselVisit().status }}</b>
</div>

<kendo-chip [fillMode]="'none'"
            [rounded]="'full'"
            [removable]="false"
            [selected]="false"
            [ngClass]="vesselVisitStatusColour(vesselVisit().status)"
            class="w-100 pointer-events-none">
    <b class="line-height-1 px-1 text-center w-100">{{ vesselVisit().status }}</b>
</kendo-chip> -->


<div class="noa__flex">
    <kendo-dropdownlist [data]="statuses()"
                        [(value)]="statusId"
                        (valueChange)="onStatusChange($event)"
                        [valuePrimitive]="true"
                        [textField]="'name'"
                        [valueField]="'id'"
                        [fillMode]="'none'"
                        [rounded]="'full'"
                        [size]="'small'"
                        [ngClass]="statusColour()"
                        [popupSettings]="{ width: 'auto'}">
        <!-- <ng-template kendoDropDownListValueTemplate
                        let-dataItem>
            <span class="text-uppercase">STATUS:&nbsp;<b>{{ dataItem }}</b></span>
        </ng-template> -->
    </kendo-dropdownlist>

    <!-- <kendo-chip [fillMode]="'none'"
                [rounded]="'full'"
                [removable]="false"
                [selected]="false"
                [ngClass]="vesselVisitStatusColour(vesselVisitState())"
                class="pointer-events-none">
        <span class="noa__chip-text">STATUS:&nbsp;<b>{{vesselVisitState()}}</b></span>
    </kendo-chip> -->
</div>